let API_BASE_URL;

if (process.env.NODE_ENV === 'production') {
  // In production, use the environment variable or a production default
  API_BASE_URL = process.env.REACT_APP_ETRUCK_API_BASE_URL;
} else {
  // In development, always use localhost
  API_BASE_URL = 'http://localhost:8000';
}

// console.log('Environment:', process.env.NODE_ENV);
// console.log('API Base URL being used:', API_BASE_URL);

export const API_ENDPOINTS = {
  // User management
  user: `${API_BASE_URL}/api/user/`,
  register: `${API_BASE_URL}/api/register/`,
  forgotPassword: `${API_BASE_URL}/api/forgotpwd/`,
  login: `${API_BASE_URL}/api/login/`,
  resetPassword: `${API_BASE_URL}/api/resetpwd/`,
  updateProfile: `${API_BASE_URL}/api/updateprofile/`,
  verifyEmail: `${API_BASE_URL}/api/verify-email/`,

  // Subscriptions
  subscribe: `${API_BASE_URL}/api/subscribe/`,
  freeSubscribe: `${API_BASE_URL}/api/free-subscription/`,
  
  // MIDAS TOU and RINs
  getMidasRins: `${API_BASE_URL}/api/getmidasrin/`,

  // Fleet planning
  getProcessedRoutes: `${API_BASE_URL}/api/getprocessedroutes/`,
  getRawRoute: `${API_BASE_URL}/api/getrawroute/`,
  getBatchRawRoutes: `${API_BASE_URL}/api/getbatchrawroutes/`,
  getAllRawRoutes: `${API_BASE_URL}/api/getallrawroutes/`,
  addRoute: `${API_BASE_URL}/api/addroute/`,
  deleteRoute: `${API_BASE_URL}/api/deleteroutes/`,
  editRoute: `${API_BASE_URL}/api/editroute/`,
  uploadRoutes: `${API_BASE_URL}/api/uploadroutes/`,

  addDepot: `${API_BASE_URL}/api/adddepot/`,
  editDepot: `${API_BASE_URL}/api/editdepot/`,
  getDepot: `${API_BASE_URL}/api/getdepot/`,
  getAllDepots: `${API_BASE_URL}/api/getalldepots/`,
  deleteDepot: `${API_BASE_URL}/api/deletedepots/`,

  getCircuits: `${API_BASE_URL}/api/getcircuits/`,

  getAllChargingStations: `${API_BASE_URL}/api/getallchargingstations/`,
  getTruckData: `${API_BASE_URL}/api/gettruckdata/`,
  getLightDutyTruckData: `${API_BASE_URL}/api/getlightdutytruckdata/`,
  getMediumDutyTruckData: `${API_BASE_URL}/api/getmediumdutytruckdata/`,
  getAllFleet: `${API_BASE_URL}/api/getallfleet/`,
  addFleet: `${API_BASE_URL}/api/addfleet/`,
  addTruck: `${API_BASE_URL}/api/addtruck/`,
  
  optimize: `${API_BASE_URL}/api/optimize/`,
  getLatestOptimization: `${API_BASE_URL}/api/getlatestoptimization/`,
  getAllOptimizations: `${API_BASE_URL}/api/getalloptimizations/`,
  getOptimization: `${API_BASE_URL}/api/getoptimization/`,
  deleteOptimization: `${API_BASE_URL}/api/deleteoptimization/`,
  
  // ACT Registration
  registerACT: `${API_BASE_URL}/api/act-registration/`,
  tokenValidationACT: `${API_BASE_URL}/api/act-token-validation/`,
  testRegister: `${API_BASE_URL}/api/test-registration/`,

  // Contact
  contact: `${API_BASE_URL}/api/contact-us/`,
}; 